module.exports = __webpack_public_path__ + "img/chat_filled.3627fe1.png";